import { React, useState, useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { Card, Typography } from 'antd';
import { useParams } from 'react-router-dom';
import { useCallback } from 'react';
import debounce from 'lodash.debounce';
import dayjs from 'dayjs';
import { CornerDownLeft } from 'lucide-react';

import { useNavigate } from 'react-router-dom';
import TaskObject from '@atlaskit/object/task';
import StoryObject from '@atlaskit/object/story';
import BugObject from '@atlaskit/object/bug';
import { Select } from 'antd';
import WebLink from '../Board/WebLink';
import WebLinkList from '../Board/ListWebLinks';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Box,
  Flex,
  Text,
  Badge,
  VStack,
  HStack,
  Tag,
  Input,
  Avatar,
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  IconButton,
  Button,
  Table,
  Thead,
  Tbody,
  TabList,
  Tab,
  Tabs,
  TabPanels,
  TabPanel,
  Tr,
  Th,
  Td,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
} from '@chakra-ui/react';
import Epicmodalactivity from './Epicmodalactivity';
import { FaLock, FaEye, FaShareAlt } from 'react-icons/fa';
import { setassigneelist } from 'store/actions';
import { useDispatch } from 'react-redux';
import { setTaskstatuslist } from 'store/actions';
import { AiOutlineThunderbolt } from 'react-icons/ai';
import { MdOutlinePerson } from 'react-icons/md';
import CreatableSelect from 'react-select/creatable';
import httpInjectorService from 'services/http-injector.service';
import { toast } from 'react-toastify';

import { Tooltip } from '@chakra-ui/react';

import { ThunderboltOutlined } from '@ant-design/icons';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import { AddIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { Spinner } from 'reactstrap';
import SkeletonWithLoaders from 'components/common/Spinner';
// import SubTaskModal from './SubTaskModal';
import UserAvatar from '../../../../components/userAvatar/index';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import LogWork from '../Board/LogWork';
import LinkWorkItemInput from '../Board/LinkWorkItemInput';
import ListLinkedWorkItems from '../Board/ListLinkedWorkItems';

const { Title } = Typography;

const NewTabEpicdetails = ({
  isOpen,
  onClose,
  epicDetails,
  fetchData,
  //   getTaskBoardDetails,
}) => {
  const [showEmployeePicker, setShowEmployeePicker] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [description, setDescription] = useState('');
  const { projectId, epicId } = useParams();

  const [isEditingepicTitle, setIsEditingepicTitle] = useState(false);
  const [issueTypes, setIssueTypes] = useState([]);
  const [selectedIssueTypeId, setSelectedIssueTypeId] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [selectedLabel, setSelectedLabel] = useState([]);
  const [labellist, setLabelList] = useState([]);
  const [epicdata, setEpicData] = useState({});
  const [sprintlist, setSprintlist] = useState({});
  const [selectedSprint, setSelectedSprint] = useState(null);
  const [comments, setComments] = useState([]);
  const [commentInput, setCommentInput] = useState('');
  const [replyInput, setReplyInput] = useState({});
  const [activeReply, setActiveReply] = useState(null);
  const [mentionQuery, setMentionQuery] = useState('');
  const [mentionSuggestions, setMentionSuggestions] = useState([]);
  const [taggedUsers, setTaggedUsers] = useState([]);
  const [newstatus, setnewstatus] = useState('');
  const [showChildInput, setShowChildInput] = useState(false);
  const [childTaskTitle, setChildTaskTitle] = useState('');
  const [childTasks, setChildTasks] = useState([]);
  const [refreshLinkedItems, setRefreshLinkedItems] = useState(false);

  const [loadingSubtasks, setLoadingSubtasks] = useState(false);
  const [editableTasks, setEditableTasks] = useState({});
  const [subtaskmodal, setSubtaskModal] = useState(false);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [epicModalOpen, setEpicModalOpen] = useState(false);
  const [selectedEpic, setSelectedEpic] = useState('');
  const [epicList, setEpicList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openLinkWorkItem, setOpenLinkWorkItem] = useState(false);
  const [visibleReplies, setVisibleReplies] = useState({});

  const [isEditingDescription, setIsEditingDescription] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const [assigneeList, setassigneeList] = useState([]);
  const [statusList, setstatusList] = useState([]);
  const [showWebLink, setShowWebLink] = useState(false);
  const [refreshLinks, setRefreshLinks] = useState(false);
  const EpicList = useSelector((state) => state?.Authentication?.Epiclist);

  const [reloadSubtasks, setReloadSubtasks] = useState(0);
  // const [activeReply, setActiveReply] = useState(null);
  const [panelOpen, setPanelOpen] = useState(isOpen);
  const [panelWidth, setPanelWidth] = useState(400);
  const [rightPaneWidth, setRightPaneWidth] = useState(380);
  const isResizingRef = useRef(false);
  useEffect(() => {
    setPanelOpen(isOpen);
  }, [isOpen]);

  const innerResizingRef = useRef(false);
  const startInnerXRef = useRef(0);

  const MIN_WIDTH = 250;
  const getMaxWidth = () =>
    Math.min(window.innerWidth * 0.5, window.innerWidth - 250);
  const [rightWidth, setRightWidth] = useState(() =>
    Math.min(Math.max(window.innerWidth * 0.4, MIN_WIDTH), getMaxWidth()),
  );

  const resizingRef = useRef(false);
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);

  const onMouseDown = (e) => {
    resizingRef.current = true;
    startXRef.current = e.clientX;
    startWidthRef.current = rightWidth;
    document.body.style.userSelect = 'none';

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  const onMouseMove = (e) => {
    if (!resizingRef.current) return;
    const dx = e.clientX - startXRef.current;

    let newW = startWidthRef.current - dx; // drag right -> shrink
    const MAX_WIDTH = getMaxWidth();
    newW = Math.min(Math.max(newW, MIN_WIDTH), MAX_WIDTH);
    setRightWidth(newW);
  };

  const onMouseUp = () => {
    resizingRef.current = false;
    document.body.style.userSelect = '';
    document.removeEventListener('mousemove', onMouseMove);
    document.removeEventListener('mouseup', onMouseUp);
  };

  // Update rightWidth dynamically on window resize
  useEffect(() => {
    const handleResize = () => {
      setRightWidth((prev) => Math.min(prev, window.innerWidth * 0.5));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //   const innerResizingRef = useRef(false);
  //   const startInnerXRef = useRef(0);
  const startRightWidthRef = useRef(0);
  const onMouseMoveInner = (e) => {
    if (!innerResizingRef.current) return;
    const dx = e.clientX - startInnerXRef.current;

    // ✅ Flip direction: drag right → shrink right box
    const newWidth = Math.min(
      Math.max(startRightWidthRef.current - dx, 250),
      700,
    );
    setRightWidth(newWidth);
  };

  const handleLogSaved = () => {
    setRefreshKey((prev) => prev + 1);
  };

  const onMouseUpInner = () => {
    innerResizingRef.current = false;
    document.removeEventListener('mousemove', onMouseMoveInner);
    document.removeEventListener('mouseup', onMouseUpInner);
  };

  const epicColors = [
    '#8b5cf6', // Purple
    '#3b82f6', // Blue
    '#10b981', // Green
    '#f59e0b', // Amber
    '#ef4444', // Red
    '#6b7280', // Gray
  ];
  // start width in px

  const [storyPoints, setStoryPoints] = useState('');
  // const assigneeList = useSelector(
  //   (state) => state?.Authentication?.assigneelist,
  // );
  // const statusList = useSelector(
  //   (status) => status?.Authentication?.taskstatuslist,
  // );

  const roleId = Number(Cookies.get('task-role-id'));
  useEffect(() => {
    setPanelOpen(isOpen);
  }, [isOpen]);

  // optional threshold to stack panes vertically when panel is narrow

  // To store tagged usernames & ids

  const handleCloseWithSave = () => {
    handleEpicUpdate();
    fetchData();
    // handleAddLabel();
    // getTaskBoardDetails();

    onClose();
  };

  const handleSaveLink = (data) => {
    
    setRefreshLinks(prev => !prev);
    setShowWebLink(false);
  };

  const getprojectAssignedEmployee = async () => {
    try {
      let response =
        await httpInjectorService.getProjectAssignedEmployeelist(projectId);
      if (response.status === 'success') {
        setassigneeList(response.data);
        dispatch(setassigneelist(response.data));
      } else {
        dispatch(setassigneelist([]));
        setassigneeList([]);
      }
    } catch (error) {
      throw error;
    }
  };

  const listBoardStatus = async () => {
    try {
      const response = await httpInjectorService.ListBoardStatus(projectId);
      if (response.status === 'success' && Array.isArray(response.data)) {
        const statusList = response?.data;
        setstatusList(statusList);
        dispatch(setTaskstatuslist(statusList));
      } else {
        // setStatus([]);
        dispatch(setTaskstatuslist([]));
        setstatusList(statusList);

        // set({});
      }
    } catch (error) {
      throw error;
    }
  };

  const getIssueIcon = (type) => {
    switch (type?.toUpperCase()) {
      case 'TASK':
        return <TaskObject size="medium" />;
      case 'BUG':
        return <BugObject size="medium" />;
      case 'STORY':
        return <StoryObject size="medium" />;
      default:
        return <TaskObject size="medium" />; // fallback
    }
  };

  const formatDateInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Still YYYY-MM-DD, but local
  };

  const [dueDate, setDueDate] = useState(formatDateInput(epicdata?.due_date));
  const [startDate, setStartDate] = useState(
    formatDateInput(epicdata?.start_date),
  );

  const toggleReplies = (commentId, totalReplies) => {
    setVisibleReplies((prev) => ({
      ...prev,
      [commentId]:
        prev[commentId] && prev[commentId] < totalReplies
          ? totalReplies // show all
          : 2, // collapse back to 2
    }));
  };

  const handleAddLabel = async (updatedLabels = selectedLabel) => {
    try {
      // Always use the latest labels passed from onChange
      if (!updatedLabels || updatedLabels.length === 0) {
      }

      const newLabels = updatedLabels.filter((label) => label.__isNew__);
      const existingLabels = updatedLabels.filter((label) => !label.__isNew__);

      const newLabelNames = newLabels.map((label) => label.label);
      const existingLabelIds = existingLabels.map((label) => label.value);

      const requestBody = {
        project_id: projectId,
        epic_id: epicId,
      };

      // Attach ONLY if present
      if (newLabelNames.length > 0) {
        requestBody.new_label_name = newLabelNames;
      }

      requestBody.labels_id = existingLabelIds; // even if empty []

      const response =
        await httpInjectorService.createandADDepicLabels(requestBody);

      if (response.status !== 'success') {
        // error toast if needed
      }
    } catch (error) {
      toast.error('Something went wrong while adding labels', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      const reqBody = {
        // project_id: taskdata.project_id,
        // task_id: taskdata.task_id,
        comment_id: commentId,
      };

      const res = await httpInjectorService.deleteEpicComment(reqBody);
      if (res.status === 'success') {
        toast.success('Comment deleted successfully');
        // gettaskcomments();
      } else {
        toast.error(res.message || 'Failed to delete comment');
      }
    } catch (error) {
      toast.error('Something went wrong while deleting comment');
    }
  };

  const handleEditComment = async (commentId, updatedText) => {
    try {
      const reqBody = {
        project_id: projectId,
        comment_id: commentId,
        comment_text: updatedText,
      };

      const res = await httpInjectorService.editEpiccomment(reqBody);
      if (res.status === 'success') {
        toast.success('Comment updated successfully');
        getEpiccomments();
      } else {
        toast.error(res.message || 'Failed to update comment');
      }
    } catch (error) {
      toast.error('Something went wrong while updating comment');
    }
  };

  const getLabelList = async () => {
    try {
      const response = await httpInjectorService.getlabelList(projectId);
      if (response.status === 'success') {
        setLabelList(response.data);
      } else {
        setLabelList([]);
      }
    } catch (error) {
      throw error;
    }
  };

  const handleOpenLinkWorkItem = () => {
    setOpenLinkWorkItem(true);
  };

  useEffect(() => {
    // when epicDetails has a value (and not just an empty object), stop loading
    setLoading(true);

    getEpicDetails();
    getIssueTypes();
    getprojectAssignedEmployee();
    listBoardStatus();
    gettaskList();
    if (epicdata) {
      setLoading(false);
    }
  }, [epicId]);

  const getEpicDetails = async () => {
    let reqbody = {
      project_id: projectId,
      epic_id: epicId,
    };
    try {
      const response = await httpInjectorService.getEpicdetails(reqbody);
      if (response.status === 'success') {
        setEpicData(response.data);
      } else {
        setEpicData({});
      }
    } catch (error) {
      throw error;
    }
  };

  const [epicColor, setEpicColor] = useState(epicdata?.epic_color || '#8b5cf6');

  const [editedepicTitle, setEditedepicTitle] = useState(
    epicdata?.epic_name || '',
  );
  const handleEditChange = (subtaskId, field, value) => {
    setEditableTasks((prev) => ({
      ...prev,
      [subtaskId]: {
        ...prev[subtaskId],
        [field]: value,
      },
    }));
  };

  const handleopensubtaskmodal = (task) => {
    setSelectedSubtask(task);
    setSubtaskModal(true);
  };

  const getStatusColors = (status = '') => {
    const s = status.toUpperCase(); // normalize

    switch (s) {
      case 'DONE':
        return { bg: 'green.300', color: 'black' };

      case 'TO DO':
        return { bg: 'gray.300', color: 'black' };

      default:
        return { bg: 'blue.300', color: 'black' };
    }
  };

  const currentStatus = newstatus || epicdata?.epic_status;
  const { bg, color } = getStatusColors(currentStatus);

  const saveSubtask = async (taskId, updatedFields = {}) => {
    const edited = editableTasks[taskId] || {};
    const original = childTasks.find((t) => t.task_id === taskId);

    if (!original) {
      return;
    }

    const reqBody = {
      project_id: projectId,
      task_id: taskId,
      epic_id: epicId,
      sprint_id: original?.sprint_id,
      task_title:
        edited.title !== undefined ? edited.title : original?.task_title,
      task_status: updatedFields.status
        ? updatedFields.status
        : original.task_status,
      task_priority: updatedFields.priority
        ? updatedFields.priority
        : original.task_priority,
      assignee_id: updatedFields.assignee_id
        ? updatedFields.assignee_id
        : original.assignee_id,
    };

    try {
      const response = await httpInjectorService.Taskedit(reqBody);
      if (response.status === 'success') {
        gettaskList();
        // Optionally refresh or give feedback
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    // gettaskcomments();
  }, []);

  const deleteChildTask = async (subtaskId) => {
    try {
      let reqbody = {
        project_id: projectId,
        task_id: [subtaskId],
      };
      let response = await httpInjectorService.deleteTask(reqbody);
      if (response.status === 'success') {
        toast.success(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
        setChildTasks((prev) =>
          prev.filter((task) => task.subtask_id !== subtaskId),
        );
      } else {
        toast.error(response.message, {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (error) {
      throw error;
    }
  };

  const getEpiccomments = async () => {
    let reqbody = {
      project_id: projectId,
      epic_id: epicId,
    };
    try {
      const res = await httpInjectorService.getEpicComments(reqbody);
      if (res.status === 'success') {
        setComments(res.data);
      } else {
        console.error('Failed to fetch comments:', res.message);
      }
    } catch (err) {
      throw err;
    }
  };

  const handleMentionSelect = (user) => {
    const words = commentInput.trim().split(/\s+/);
    words.pop(); // remove @something
    words.push(`@${user.username}`);
    const newText = words.join(' ') + ' ';
    setCommentInput(newText);
    setTaggedUsers((prev) => [...prev, user]); // Store tagged user info
    setMentionSuggestions([]);
    setMentionQuery('');
  };

  const handleColorChange = (color) => {
    setEpicColor(color);

    // Update the epic color immediately
    handleEpicUpdate({ epic_color: color });
  };

  //   useEffect(() => {
  //     if (taskdata?.epic_id) {
  //       const found = EpicList.find((epic) => epic.epic_id === taskdata.epic_id);
  //       if (found) {
  //         setSelectedParent({ value: found.epic_id, label: found.epic_name });
  //       }
  //     }
  //   }, [taskdata, EpicList]);

  const getsprintlist = async () => {
    try {
      let response = await httpInjectorService.getsprintList(projectId);

      if (response.status === 'success') {
        const activeSprints = response.data?.active_sprints || [];

        // Convert to options format for CreatableSelect
        const options = activeSprints.map((sprint) => ({
          label: sprint.sprint_name,
          value: sprint.sprint_id,
        }));

        setSprintlist(options);

        // Preselect based on taskDetails
        const currentSprintName = epicdata?.sprint_name || ' ';
        const matchedSprint = options.find(
          (opt) => opt.label === currentSprintName,
        );

        if (matchedSprint) {
          setSelectedSprint(matchedSprint);
        }
      } else {
        setSprintlist([]);
      }
    } catch (error) {
      setSprintlist([]);
    }
  };

  useEffect(() => {
    if (epicId) {
      getsprintlist();
      getLabelList();
      getEpiccomments();
      getEpicDetails();
      gettaskList();
    }
  }, [epicId]);

  useEffect(() => {
    if (epicId) {
      getsprintlist();
      setDescription(epicdata?.description);
      setDueDate(formatDateInput(epicdata?.due_date) || '');
      setStartDate(formatDateInput(epicdata?.start_date) || '');
      setStoryPoints(epicdata?.epic_story_points ?? '');
    }
  }, [isOpen, epicdata]);

  const sprintOptions = Array.isArray(sprintlist)
    ? sprintlist
    : sprintlist?.data || [];

  const handleEpicUpdate = async (emp = {}) => {
    const finalBody = {
      project_id: projectId,
      epic_id: epicId,
      epic_name: editedepicTitle || epicDetails?.name,
      sprint_id: selectedSprint?.value || epicdata?.sprint_id || null,
      epic_story_points: storyPoints || epicdata?.epic_story_points || null,
      assignee_id: emp?.user_id || epicdata?.assignee_id || null,

      description: description?.trim() || epicdata?.description || '',
      epic_status: emp?.status_name || epicdata?.epic_status,
      task_priority: epicdata.task_priority,
      start_date: startDate || epicdata?.start_date,
      due_date: dueDate || epicdata?.due_date,
      epic_colour: epicColor || epicdata?.epic_colour,
    };

    try {
      const response = await httpInjectorService.UpdateEpicDetails(finalBody);
      if (response?.status === 'success') {
        getEpicDetails();
        // getTaskBoardDetails();
      }
    } catch (error) {
      toast.error('Something went wrong.');
    }
  };
  const getIssueTypes = async () => {
    try {
      const response = await httpInjectorService.getIssueTypes();

      if (response.status === 'success') {
        setIssueTypes(response.data);
      }
    } catch (error) {
      throw error;
    }
  };

  const triggerRefresh = () => {
    setRefreshLinkedItems((prev) => !prev); // toggle
  };

  const debouncedUpdate = useCallback(
    debounce(() => handleEpicUpdate(), 400),
    [handleEpicUpdate],
  );

  const handleCommentChange = (value) => {
    setCommentInput(value);

    // Find the last "@mention" pattern anywhere in the text
    const match = value.match(/@(\w*)$/);

    if (match) {
      const query = match[1].toLowerCase();
      const suggestions = assigneeList.filter((user) =>
        user.username.toLowerCase().includes(query),
      );
      setMentionQuery(query);
      setMentionSuggestions(suggestions);
    } else {
      setMentionQuery('');
      setMentionSuggestions([]);
    }
  };

  const justOpenedRef = useRef(true);

  useEffect(() => {
    if (epicModalOpen) {
      //   getEpiclist(); // fetch only when modal is opened
    }
  }, [epicModalOpen]);

  const gettaskList = async () => {
    setLoadingSubtasks(true);
    let reqbody = {
      project_id: projectId,
      epic_id: epicId,
    };
    try {
      const response = await httpInjectorService.gettaskwithEpicId(reqbody);
      setChildTasks(response?.data);

      // assuming array of { id, title }
    } catch (error) {
      console.error('Error fetching subtasks:', error);
    } finally {
      setLoadingSubtasks(false);
    }
  };

  const isEditable = [1, 2, 3].includes(roleId);

  // useEffect(() => {
  //   // getsubtaskList();
  // }, [taskdata?.task_id]);

  const handleAddSubtask = async () => {
    let reqbody = {
      project_id: projectId,
      epic_id: epicId,
      sprint_id: epicdata.sprint_id,
      issue_title: childTaskTitle || '',
      issue_type_id: selectedIssueTypeId,
      description: null,
      subtask_status: 'TO DO',
      subtask_priority: 'Medium',
      start_date: null,
      due_date: null,
      labels_id: null,
      subtask_assignee_id: null,
    };

    try {
      const response = await httpInjectorService.addtaskwithEpic(reqbody);
      if (response.status === 'success') {
        setChildTaskTitle('');
        setShowChildInput(false);
        setReloadSubtasks((prev) => prev + 1);
        gettaskList(); // Refresh list
      } else {
        console.error('Failed to add subtask');
      }
    } catch (error) {
      throw error;
    }
  };

  const handlesubtaskmodal = () => {
    setSubtaskModal(false);
  };

  // const updatesubtask=async()=>{

  //   let reqbody={
  //     project_id:5,
  // subtask_id: 11,
  // title: "subtask edit test_12",
  // subtask_status: "Blocked",
  // subtask_priority: "Medium",
  // subtask_assignee_id: 157
  //   }
  //   try{
  //     let response=await httpInjectorService.updateSubtask(reqbody)
  //     if(response.status==="success"){

  //     }
  //   }catch(error){

  //   }
  // }

  useEffect(() => {
    if (isOpen) {
      justOpenedRef.current = true;
    }
  }, [isOpen]);

  const handleStatusChange = (status) => {
    setnewstatus(status);
  };

  const formatAssigneeLabel = (username) => {
    if (!username) return 'Unassigned';

    const nameParts = username.trim().split(' ');
    const initials = nameParts
      .map((n) => n[0])
      .join('')
      .toUpperCase();

    return `${initials} - ${username}`;
  };

  const handleCancel = () => {
    setEditedepicTitle(epicdata?.task_title || '');
    setIsEditingepicTitle(false);
  };

  useEffect(() => {
    if (epicdata?.labels) {
      const formatted = epicdata.labels.map((label) => ({
        label: label.label_name,
        value: label.label_id,
        __isNew__: false,
      }));
      setSelectedLabel(formatted);
    }
  }, [epicdata]);

  const status = epicdata?.task_status_count || {};
  const done = parseInt(status?.DONE || 0, 10);
  const total = parseInt(status?.task_count || 0, 10);
  const donePercent = total > 0 ? (done / total) * 100 : 0;

  return (
    <Card
      style={{
        position: 'fixed',
        top: '60px',
        left: '80px',
        right: '10px',
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <div>
        <Flex justify="space-between" align="center">
          <HStack spacing={0} align="center">
            <HStack spacing={1} align="center">
              {/* <Text fontSize="sm" color="gray.600">
                    {taskdata?.epic_key || selectedEpic ? (
                      // prefer selectedEpic if chosen, otherwise fallback to taskdata.epic_key
                      epicList.find(
                        (epic) =>
                          epic.epic_id === (selectedEpic || taskdata.epic_key),
                      )?.epic_key || taskdata.epic_key
                    ) : (
                      <Button
                        onClick={() => setEpicModalOpen(true)}
                        variant="ghost"
                        size="xs"
                        p={0}
                        minW="auto"
                        height="auto"
                        color="gray.500"
                        _hover={{ bg: 'transparent', color: 'gray.600' }}
                        leftIcon={<FaEdit size="12px" />}
                      >
                        Add epic
                      </Button>
                    )}
                  </Text> */}
              <Text fontSize="sm" color="gray.600">
                <span>
                  <ThunderboltOutlined style={{ color: '#884B9E' }} />{' '}
                  {epicdata?.epic_key}
                </span>
              </Text>
            </HStack>

            {/* <Text fontSize="sm" color="gray.500">
                  {taskDetails?.task?.task_key || taskDetails?.task_key}
                </Text> */}
          </HStack>

          <HStack spacing={2}>
            <IconButton
              icon={<FaLock />}
              size="sm"
              variant="ghost"
              aria-label="lock"
            />
            <LogWork
              work_Id={epicdata?.epic_id}
              work_Type="EPIC"
              taskDetails={epicdata}
              onSaved={handleLogSaved}
            />
            <IconButton
              icon={<FaEye />}
              size="sm"
              variant="ghost"
              aria-label="view"
            />
            <IconButton
              icon={<FaShareAlt />}
              size="sm"
              variant="ghost"
              aria-label="share"
            />
            <IconButton
              icon={<AiOutlineThunderbolt />}
              size="sm"
              variant="ghost"
              aria-label="action"
            />
          </HStack>
        </Flex>
        <Box
          width="100%"
          height="100%"
          display="flex"
          flexDirection="row"
          bg="white"
          overflowY="auto"
        >
          {loading ? (
            <Flex justify="center" align="center" w="100%" h="300px">
              <SkeletonWithLoaders />
            </Flex>
          ) : (
            <Flex width="100%">
              <Box
                flex="1"
                p={6}
                overflowY="auto"
                bg="white"
                style={{
                  height: 'calc(100vh - 180px)', // adjust top/bottom offset as needed
                  display: 'flex',
                  flexDirection: 'column',
                  overflowY: 'auto', // vertical scrolling
                  // prevent horizontal scroll
                  transition: 'height 0.2s ease', // smooth height change
                }}
              >
                <Box mb={4}>
                  <HStack align="center" spacing={3}>
                    {/* COLOR BOX (always visible) */}
                    <Menu>
                      <MenuButton>
                        <Box
                          width="24px"
                          height="24px"
                          borderRadius="4px"
                          cursor="pointer"
                          border="1px solid #ddd"
                          bg={epicColor}
                        />
                      </MenuButton>

                      <MenuList p={2}>
                        <HStack spacing={2}>
                          {epicColors.map((color) => (
                            <Box
                              key={color}
                              width="24px"
                              height="24px"
                              borderRadius="4px"
                              bg={color}
                              cursor="pointer"
                              border={
                                epicColor === color
                                  ? '2px solid black'
                                  : '1px solid #ccc'
                              }
                              onClick={() => handleColorChange(color)}
                            />
                          ))}
                        </HStack>
                      </MenuList>
                    </Menu>

                    {/* EPIC TITLE TEXT / INPUT */}
                    {!isEditingepicTitle ? (
                      <Text
                        fontSize="2xl"
                        fontWeight="bold"
                        cursor="pointer"
                        onClick={() => {
                          if ([1, 2, 3].includes(roleId)) {
                            setEditedepicTitle(epicdata?.epic_name);
                            setIsEditingepicTitle(true);
                          }
                        }}
                      >
                        {editedepicTitle || epicdata?.epic_name || 'Epic Title'}
                      </Text>
                    ) : (
                      <Box position="relative" width="100%">
                        <Input
                          value={editedepicTitle}
                          onChange={(e) => setEditedepicTitle(e.target.value)}
                          size="lg"
                          fontSize="2xl"
                          fontWeight="bold"
                          autoFocus
                          height="40px"
                          focusBorderColor="gray.300"
                          borderRadius="md"
                        />

                        <HStack
                          spacing={2}
                          position="absolute"
                          right="0"
                          top="100%"
                          mt={1}
                          pointerEvents="none"
                        >
                          <Box
                            p={1}
                            border="1px solid #d1d5db"
                            borderRadius="sm"
                            cursor="pointer"
                            pointerEvents="auto"
                            onClick={() => {
                              handleEpicUpdate({
                                title: editedepicTitle,
                                color: epicColor,
                              });
                              setIsEditingepicTitle(false);
                            }}
                          >
                            <CheckIcon boxSize={4} color="grey" />
                          </Box>

                          <Box
                            p={1}
                            border="1px solid #d1d5db"
                            borderRadius="sm"
                            cursor="pointer"
                            pointerEvents="auto"
                            onClick={handleCancel}
                          >
                            <CloseIcon boxSize={4} color="grey" />
                          </Box>
                        </HStack>
                      </Box>
                    )}
                  </HStack>

                  {/* <Menu>
                      <MenuButton
                        as={IconButton}
                        icon={<AddIcon />}
                        size="sm"
                        colorScheme="gray"
                        variant="ghost"
                        mt={1}
                        aria-label="Add actions"
                      />
                      <MenuList>
                        <MenuItem onClick={() => setShowChildInput(true)}>
                          Create child work item
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Assign task clicked')}
                        >
                          Add connected work
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Add attachment clicked')}
                        >
                          Add Attachment
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Add comment clicked')}
                        >
                          Add web link
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Assign task clicked')}
                        >
                          Page
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Add attachment clicked')}
                        >
                          Whiteboard
                        </MenuItem>
                      </MenuList>
                    </Menu> */}

                  {[1, 2, 3].includes(roleId) && (
                    <Menu>
                      <MenuButton
                        as={IconButton}
                        icon={<AddIcon />}
                        size="sm"
                        aria-label="Add actions"
                        bg="#f3f4f6"
                        border="1px solid #d1d5db"
                        borderRadius="md"
                        _hover={{ bg: '#e5e7eb' }}
                        _active={{ bg: '#e5e7eb' }}
                        color="gray.700"
                        mt={1}
                        mb={30}
                        position="relative"
                        zIndex={1}
                      />
                      <MenuList zIndex={2}>
                        <MenuItem onClick={() => setShowChildInput(true)}>
                          Create child work item
                        </MenuItem>
                        <MenuItem onClick={handleOpenLinkWorkItem}>
                          Link work Items
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Assign task clicked')}
                        >
                          Add connected work
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Add attachment clicked')}
                        >
                          Add Attachment
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                                    console.log('clicked');
                                    setShowWebLink(true);
                                  }}
                        >
                          Add web link
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Assign task clicked')}
                        >
                          Page
                        </MenuItem>
                        <MenuItem
                          onClick={() => console.log('Add attachment clicked')}
                        >
                          Whiteboard
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  )}
                </Box>

                <Box mb={6}>
                  <Text fontWeight="semibold" mb={2}>
                    Description
                  </Text>

                  {!isEditingDescription ? (
                    <Box
                      p={3}
                      border="1px solid #e2e8f0"
                      borderRadius="8px"
                      minH="80px"
                      bg="white"
                      onClick={() =>
                        [1, 2, 3].includes(roleId) &&
                        setIsEditingDescription(true)
                      }
                      cursor={
                        ![1, 2, 3].includes(roleId) ? 'not-allowed' : 'text'
                      }
                      fontSize="lg"
                    >
                      {description ? (
                        <Box
                          dangerouslySetInnerHTML={{ __html: description }}
                          fontSize="md"
                        />
                      ) : (
                        <Text color="gray.400" fontSize="md">
                          Add a description...
                        </Text>
                      )}
                    </Box>
                  ) : (
                    <Box>
                      <ReactQuill
                        theme="snow"
                        value={description}
                        onChange={setDescription}
                        placeholder="Write a description..."
                        modules={{
                          toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            [{ list: 'ordered' }, { list: 'bullet' }],
                            [{ color: [] }, { background: [] }],
                            ['link', 'image', 'code-block'],
                            ['clean'],
                          ],
                        }}
                        style={{
                          backgroundColor: 'white',
                          borderRadius: '8px',
                          minHeight: '120px',
                          fontSize: '16px',
                          lineHeight: '1.5',
                        }}
                      />
                      <Flex justify="flex-end" mt={1} gap={2}>
                        <Button
                          size="sm"
                          colorScheme="blue"
                          borderRadius="0px"
                          onClick={() => {
                            setIsEditingDescription(false);
                            handleEpicUpdate('description', description);
                          }}
                        >
                          Save
                        </Button>
                        <Button
                          size="sm"
                          variant="ghost"
                          borderRadius="0px"
                          onClick={() => setIsEditingDescription(false)}
                        >
                          cancel
                        </Button>
                      </Flex>
                    </Box>
                  )}
                </Box>

                 {openLinkWorkItem && (
                  <div style={{ marginTop: '16px' }}>
                    <LinkWorkItemInput
                      onCancel={() => setOpenLinkWorkItem(false)}
                      current_item_type={'epic'}
                      current_item_id={epicdata.epic_id}
                      onSuccess={triggerRefresh}
                    />
                  </div>
                )}

                  {showWebLink && (
                                                                    <WebLink
                                                                      onClose={() => setShowWebLink(false)}
                                                                      onSave={handleSaveLink}
                                                                      work_id={epicDetails.epic_id}
                                                                      work_type={'epic'}
                                                                    />
                                                                  )}
                <Tabs variant="unstyled">
                  {/* Tabs */}
                  <TabList gap={2}>
                    <Tab
                      fontSize="12px"
                      px="8px"
                      py="3px"
                      _selected={{
                        border: '1px solid #3182CE',
                        color: '#3182CE',
                        bg: 'white',
                        borderRadius: '4px',
                      }}
                    >
                      Subtasks
                    </Tab>

                    <Tab
                      fontSize="12px"
                      px="8px"
                      py="3px"
                      _selected={{
                        border: '1px solid #3182CE',
                        color: '#3182CE',
                        bg: 'white',
                        borderRadius: '4px',
                      }}
                    >
                      Linked Items
                    </Tab>
                  </TabList>

                  {/* Tab Content */}
                  <TabPanels mt={4}>
                    {/* Subtasks */}
                    <TabPanel p={0}>
                      {childTasks?.length > 0 && [1, 2, 3].includes(roleId) && (
                        <Box mt={6}>
                          <Text fontWeight="semibold" mb={2}>
                            Child work items
                          </Text>
                          {epicdata?.task_status_count && (
                            <Box mb={1}>
                              <Flex align="center" gap={4}>
                                {/* Progress Bar */}
                                <Flex
                                  w="100%"
                                  h="10px"
                                  borderRadius="8px"
                                  overflow="hidden"
                                  bg="#E2E8F0"
                                >
                                  {(() => {
                                    const counts = epicdata.task_status_count;
                                    const total =
                                      Number(
                                        epicdata?.task_status_count?.task_count,
                                      ) || 1;

                                    // Fixed
                                    const todo = Number(counts['TO DO'] || 0);
                                    const done = Number(counts['DONE'] || 0);

                                    // Dynamic statuses (merged into BLUE)
                                    let blue = 0;
                                    let blueStatusText = [];

                                    Object.keys(counts).forEach((key) => {
                                      if (
                                        key !== 'TO DO' &&
                                        key !== 'DONE' &&
                                        key !== 'task_count'
                                      ) {
                                        const c = Number(counts[key] || 0);
                                        blue += c;
                                        blueStatusText.push(`${key}: ${c}`);
                                      }
                                    });

                                    const todoPercent = (todo / total) * 100;
                                    const bluePercent = (blue / total) * 100;
                                    const donePercent = (done / total) * 100;

                                    return (
                                      <>
                                        {/* DONE (green) */}

                                        <Tooltip
                                          label={`DONE: ${done} of ${total}`}
                                          hasArrow
                                          placement="top"
                                        >
                                          <Box
                                            w={`${donePercent}%`}
                                            bg="#38A169"
                                            mx="1px"
                                            borderRadius="4px"
                                          />
                                        </Tooltip>

                                        {/* BLUE (other statuses) */}
                                        <Tooltip
                                          label={`IN PROGRESS: ${blue} of ${total}`}
                                          hasArrow
                                          placement="top"
                                        >
                                          <Box
                                            w={`${bluePercent}%`}
                                            bg="#3182CE"
                                            mx="1px"
                                            borderRadius="4px"
                                          />
                                        </Tooltip>
                                        {/* TO DO (grey) */}
                                        <Tooltip
                                          label={`TO DO: ${todo} of ${total}`}
                                          hasArrow
                                          placement="top"
                                        >
                                          <Box
                                            w={`${todoPercent}%`}
                                            bg="#A0AEC0"
                                            mx="1px"
                                            borderRadius="4px"
                                          />
                                        </Tooltip>
                                      </>
                                    );
                                  })()}
                                </Flex>

                                {/* Work Done Percentage */}
                                <Text fontWeight="600" whiteSpace="nowrap">
                                  Done: {Math.round(donePercent)}%
                                </Text>
                              </Flex>
                            </Box>
                          )}

                          <Box
                            borderWidth="1px"
                            borderRadius="md"
                            overflow="hidden"
                            boxShadow="sm"
                          >
                            <Box maxH="300px" overflowY="auto">
                              <Table size="sm" border="1px solid #E2E8F0">
                                <Thead
                                  bg="gray.100"
                                  position="sticky"
                                  top={0}
                                  zIndex={0}
                                >
                                  <Tr>
                                    <Th borderRight="1px solid #E2E8F0"></Th>
                                    <Th
                                      borderRight="1px solid #E2E8F0"
                                      w="300px"
                                    >
                                      Work
                                    </Th>
                                    <Th
                                      borderRight="1px solid #E2E8F0"
                                      w="100px"
                                    >
                                      Priority
                                    </Th>
                                    <Th borderRight="1px solid #E2E8F0">
                                      Assignee
                                    </Th>
                                    <Th>Status</Th>
                                    {/* <Th>Actions</Th> */}
                                  </Tr>
                                </Thead>

                                <Tbody>
                                  {childTasks.map((task) => {
                                    const edited =
                                      editableTasks[task.task_id] || {};

                                    const assigneeIdToUse =
                                      edited.assignee_id !== undefined
                                        ? edited.assignee_id
                                        : task.assignee_id;

                                    const assigneeObj = assigneeList.find(
                                      (a) => a.user_id === assigneeIdToUse,
                                    );

                                    const subtaskTitle =
                                      edited.title !== undefined
                                        ? edited.title
                                        : task.issue_title;
                                    const selectedStatus =
                                      edited.status ||
                                      task.issue_status ||
                                      'TO DO';
                                    const handleSave = () =>
                                      saveSubtask(task.task_id);

                                    return (
                                      <Tr key={task.task_id}>
                                        <Td
                                          w="130px"
                                          borderRight="1px solid #E2E8F0"
                                        >
                                          <Box
                                            as="button"
                                            onClick={() => {
                                              navigate(
                                                `/admin/taskBoard/${projectId}/taskDetails/${task.task_id}`,
                                              );
                                            }}
                                            display="flex"
                                            alignItems="center"
                                            gap="6px"
                                            bg="transparent"
                                            border="none"
                                            cursor="pointer"
                                            color="#3182ce"
                                            fontWeight="500"
                                            padding={0}
                                            _hover={{
                                              textDecoration: 'underline',
                                              color: '#0056b3',
                                            }} // blue hover link
                                          >
                                            {getIssueIcon(task.issue_name)}
                                            {task.issue_key}
                                          </Box>
                                        </Td>

                                        {/* Editable title */}
                                        <Td
                                          borderRight="1px solid #E2E8F0"
                                          w="350px"
                                        >
                                          <Tooltip
                                            label={subtaskTitle}
                                            hasArrow
                                            placement="top"
                                            openDelay={300}
                                          >
                                            <Input
                                              size="sm"
                                              value={subtaskTitle}
                                              onChange={(e) =>
                                                handleEditChange(
                                                  task.issue_id,
                                                  'title',
                                                  e.target.value,
                                                )
                                              }
                                              onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                  e.target.blur(); // lose focus first
                                                  handleSave();
                                                }
                                              }}
                                              onBlur={() => {
                                                // Only save if value actually changed
                                                if (
                                                  subtaskTitle !==
                                                  task.issue_title
                                                ) {
                                                  handleSave();
                                                }
                                              }}
                                            />
                                          </Tooltip>
                                        </Td>

                                        {/* Priority */}
                                        <Td
                                          borderRight="1px solid #E2E8F0"
                                          w="80px"
                                        >
                                          <Menu>
                                            <MenuButton
                                              as={Button}
                                              size="xs"
                                              variant="outline"
                                              colorScheme="gray"
                                              rightIcon={<ChevronDownIcon />}
                                            >
                                              {edited.priority ||
                                                task.issue_priority ||
                                                'Medium'}
                                            </MenuButton>
                                            <MenuList>
                                              {['Low', 'Medium', 'High'].map(
                                                (priority) => (
                                                  <MenuItem
                                                    key={priority}
                                                    onClick={() => {
                                                      handleEditChange(
                                                        task.issue_id,
                                                        'priority',
                                                        priority,
                                                      );
                                                      saveSubtask(
                                                        task.issue_id,
                                                        {
                                                          priority,
                                                        },
                                                      );
                                                    }}
                                                  >
                                                    {priority}
                                                  </MenuItem>
                                                ),
                                              )}
                                            </MenuList>
                                          </Menu>
                                        </Td>

                                        {/* Assignee */}
                                        <Td
                                          borderRight="1px solid #E2E8F0"
                                          w="40px"
                                        >
                                          <Menu isLazy>
                                            <Tooltip
                                              label={
                                                assigneeObj
                                                  ? assigneeObj.username
                                                  : 'Unassigned'
                                              }
                                              hasArrow
                                              placement="top"
                                              openDelay={300}
                                            >
                                              <MenuButton
                                                as={Button}
                                                variant="ghost"
                                                size="sm"
                                                rightIcon={<ChevronDownIcon />}
                                              >
                                                <Box>
                                                  <UserAvatar
                                                    username={
                                                      assigneeObj
                                                        ? assigneeObj.username
                                                        : 'Unassigned'
                                                    }
                                                    size={24}
                                                  />
                                                </Box>
                                              </MenuButton>
                                            </Tooltip>

                                            <MenuList
                                              maxH="200px"
                                              overflowY="auto"
                                              zIndex={1500}
                                            >
                                              {assigneeList.map((assignee) => (
                                                <MenuItem
                                                  key={assignee.user_id}
                                                  onClick={() => {
                                                    handleEditChange(
                                                      task.issue_id,
                                                      'assignee_id',
                                                      assignee.user_id,
                                                    );
                                                    saveSubtask(task.issue_id, {
                                                      assignee_id:
                                                        assignee.user_id,
                                                    });
                                                  }}
                                                >
                                                  <Tooltip
                                                    label={assignee.username}
                                                    hasArrow
                                                    placement="right"
                                                    openDelay={300}
                                                  >
                                                    <Flex
                                                      align="center"
                                                      gap="2"
                                                    >
                                                      <UserAvatar
                                                        username={
                                                          assignee.username
                                                        }
                                                        size={24}
                                                      />
                                                      <Text fontSize="sm">
                                                        {assignee.username}
                                                      </Text>
                                                    </Flex>
                                                  </Tooltip>
                                                </MenuItem>
                                              ))}
                                            </MenuList>
                                          </Menu>
                                        </Td>

                                        {/* Status */}
                                        <Td w="100px">
                                          <Menu>
                                            <MenuButton
                                              as={Button}
                                              size="xs"
                                              variant="outline"
                                              colorScheme="gray"
                                              rightIcon={<ChevronDownIcon />}
                                            >
                                              {selectedStatus}
                                            </MenuButton>
                                            <MenuList>
                                              {statusList.map((status) => (
                                                <MenuItem
                                                  key={status.status_name}
                                                  onClick={() => {
                                                    handleEditChange(
                                                      task.task_id,
                                                      'status',
                                                      status.status_name,
                                                    );
                                                    saveSubtask(task.issue_id, {
                                                      status:
                                                        status.status_name,
                                                    });
                                                  }}
                                                >
                                                  {status.status_name}
                                                </MenuItem>
                                              ))}
                                            </MenuList>
                                          </Menu>
                                        </Td>

                                        {/* Actions */}
                                        {/* <Td>
                                                    <Flex align="center" gap={2}>
                                                      <Button
                                                        size="xs"
                                                        colorScheme="blue"
                                                        onClick={() =>
                                                          saveSubtask(task.task_id)
                                                        }
                                                      >
                                                        Save
                                                      </Button>
                                                      <Menu>
                                                        <MenuButton
                                                          as={IconButton}
                                                          icon={<FiMoreHorizontal />}
                                                          variant="ghost"
                                                          size="sm"
                                                        />
                                                        <MenuList>
                                                          {[1, 2, 3].includes(roleId) && (
                                                            <MenuItem
                                                              icon={
                                                                <DeleteIcon color="red.500" />
                                                              }
                                                              onClick={() =>
                                                                deleteChildTask(task.task_id)
                                                              }
                                                              minW="auto"
                                                            >
                                                              Delete
                                                            </MenuItem>
                                                          )}
                                                        </MenuList>
                                                      </Menu>
                                                    </Flex>
                                                  </Td> */}
                                      </Tr>
                                    );
                                  })}
                                </Tbody>
                              </Table>
                            </Box>
                          </Box>
                        </Box>
                      )}
                    </TabPanel>

                    {/* Linked Items */}
                    <TabPanel p={0}>
                      <ListLinkedWorkItems
                        item_id={epicId}
                        item_type={'epic'}
                        refreshFlag={refreshLinkedItems}
                      />
                    </TabPanel>
                  </TabPanels>
                </Tabs>

                {showChildInput && (
                  <HStack mb={4} mt={3} align="center" spacing={3} w="100%">
                    <Text fontWeight="semibold" minW="70px">
                      Subtask
                    </Text>

                    {/* Input + Select container */}
                    <HStack
                      border="1px solid #CBD5E0"
                      borderRadius="6px"
                      bg="white"
                      spacing={0}
                      flex="1"
                      h="36px"
                      overflow="hidden"
                    >
                      {/* Input */}
                      <Input
                        variant="unstyled"
                        placeholder="What needs to be done?"
                        size="sm"
                        value={childTaskTitle}
                        onChange={(e) => setChildTaskTitle(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && childTaskTitle.trim()) {
                            handleAddSubtask();
                          }
                        }}
                        pl={3}
                        h="100%"
                      />

                      {/* Divider */}
                      <Box w="1px" h="60%" bg="#E2E8F0" />

                      {/* Select wrapper */}
                      <Box
                        h="100%"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        px={1}
                        minW="52px" // 👈 important
                      >
                        <Select
                          value={selectedIssueTypeId}
                          onChange={(value) => setSelectedIssueTypeId(value)}
                          size="small"
                          bordered={false}
                          optionLabelProp="label" // 👈 icon only when selected
                          style={{
                            width: 50,
                            background: '#F7FAFC',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                          dropdownStyle={{ zIndex: 99999 }}
                        >
                          {issueTypes.map((type) => (
                            <Select.Option
                              key={type.issue_type_id}
                              value={type.issue_type_id}
                              label={
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                  }}
                                >
                                  {type.issue_type === 'TASK' && (
                                    <TaskObject width={25} stroke="#0052CC" />
                                  )}
                                  {type.issue_type === 'STORY' && (
                                    <StoryObject width={25} stroke="#36B37E" />
                                  )}
                                  {type.issue_type === 'BUG' && (
                                    <BugObject width={25} stroke="#FF5630" />
                                  )}
                                </div>
                              }
                            >
                              {/* Dropdown item: icon + text */}
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 6,
                                }}
                              >
                                {type.issue_type === 'TASK' && (
                                  <TaskObject width={18} stroke="#0052CC" />
                                )}
                                {type.issue_type === 'STORY' && (
                                  <StoryObject width={18} stroke="#36B37E" />
                                )}
                                {type.issue_type === 'BUG' && (
                                  <BugObject width={18} stroke="#FF5630" />
                                )}
                                <span>{type.issue_type}</span>
                              </div>
                            </Select.Option>
                          ))}
                        </Select>
                      </Box>
                    </HStack>

                    {/* Add */}
                    <Button
                      size="sm"
                      colorScheme="blue"
                      borderRadius="0px"
                      onClick={handleAddSubtask}
                      isDisabled={!childTaskTitle.trim()}
                    >
                      <CornerDownLeft />
                    </Button>

                    {/* Cancel */}
                    <Button
                      size="sm"
                      borderRadius="0px"
                      onClick={() => setShowChildInput(false)}
                    >
                      Cancel
                    </Button>
                  </HStack>
                )}

                {/* Comment Input */}
               
                                                                  <WebLinkList
                                                                    work_id={epicDetails.epic_id}
                                                                    work_type={'epic'}
                                                                    refreshFlag={refreshLinks}
                                                                  />

                <Box>
                  <Epicmodalactivity
                    epicDetails={epicdata}
                    refreshKey={refreshKey}
                  />
                </Box>
              </Box>
              <Box
                width="6px"
                cursor="ew-resize"
                bg="gray.200"
                _hover={{ bg: 'gray.400' }}
                onMouseDown={onMouseDown}
              />
              <Box
                flex="none"
                width={`${rightWidth}px`}
                p={6}
                pr={0}
                right={0}
                borderLeft="1px solid #e2e8f0"
                // bg="gray.50"
                overflowY="auto"
                style={{
                  height: 'calc(100vh - 180px)', // adjust top/bottom offset as needed
                  // display: 'flex',
                  flexDirection: 'column',
                  overflowY: 'auto', // vertical scrolling
                  // prevent horizontal scroll
                  transition: 'height 0.2s ease', // smooth height change
                }}
              >
                <Tooltip
                  label={!isEditable ? 'You do not have permission' : ''}
                >
                  <Menu isDisabled={!isEditable}>
                    <MenuButton
                      as={Button}
                      rightIcon={<ChevronDownIcon />}
                      size="sm"
                      mb={4}
                      p={0}
                      px={0}
                      minW="fit-content"
                      width="fit-content"
                      height="auto"
                      borderRadius="md"
                      bg={bg} // status background
                      color={color} // text color
                      border="1px solid #ccc"
                      _hover={{ bg }}
                      _active={{ bg }}
                    >
                      <Badge
                        bg="transparent"
                        color={color}
                        fontSize="0.8em"
                        p={1}
                      >
                        {currentStatus}
                      </Badge>
                    </MenuButton>

                    {isEditable && (
                      <MenuList>
                        {statusList.map((status) => {
                          const { bg, color } = getStatusColors(
                            status.status_name,
                          );
                          return (
                            <MenuItem
                              key={status.id}
                              onClick={() => {
                                handleStatusChange(status.status_name);
                                handleEpicUpdate(status);
                              }}
                            >
                              <Badge
                                bg={bg}
                                color={color}
                                fontSize="0.75em"
                                p={1}
                                borderRadius="md"
                              >
                                {status.status_name}
                              </Badge>
                            </MenuItem>
                          );
                        })}
                      </MenuList>
                    )}
                  </Menu>
                </Tooltip>

                <Grid
                  templateColumns="120px 1fr"
                  rowGap={5}
                  columnGap={6}
                  alignItems="start"
                >
                  <Text fontWeight="semibold">Assignee</Text>
                  <Tooltip
                    label={!isEditable ? 'You do not have permission' : ''}
                  >
                    <Popover
                      isOpen={showEmployeePicker}
                      onClose={() => setShowEmployeePicker(false)}
                    >
                      <Box position="relative" width="fit-content">
                        <PopoverTrigger>
                          <HStack
                            spacing={2}
                            onClick={() =>
                              setShowEmployeePicker(!showEmployeePicker)
                            }
                            cursor="pointer"
                          >
                            {selectedEmployee?.username ||
                            epicdata?.assignee_name ? (
                              <>
                                <UserAvatar
                                  username={
                                    selectedEmployee?.username ||
                                    epicdata?.assignee_name
                                  }
                                  size={24}
                                />
                                <Text fontSize="sm">
                                  {selectedEmployee?.username ||
                                    epicdata?.assignee_name}
                                </Text>
                              </>
                            ) : (
                              <HStack spacing={1} color="gray.500">
                                <MdOutlinePerson size={20} />
                                <Text fontSize="sm">Unassigned</Text>
                              </HStack>
                            )}
                          </HStack>
                        </PopoverTrigger>
                      </Box>
                      {isEditable && (
                        <PopoverContent width="auto">
                          <PopoverBody>
                            {assigneeList?.length > 0 ? (
                              <Box maxH="200px" overflowY="auto">
                                {assigneeList.map((emp) => (
                                  <Box
                                    key={emp.user_id}
                                    onClick={() => {
                                      setSelectedEmployee(emp);
                                      setShowEmployeePicker(false);
                                      handleEpicUpdate(emp); // ✅ Save immediately on assignee change
                                    }}
                                    display="flex"
                                    alignItems="center"
                                    px={2}
                                    py={1}
                                    borderRadius="md"
                                    cursor="pointer"
                                    bg={
                                      selectedEmployee?.user_id === emp.user_id
                                        ? '#e6f4ff'
                                        : 'transparent'
                                    }
                                    _hover={{ bg: '#f1f5f9' }}
                                  >
                                    <UserAvatar
                                      username={emp.username}
                                      size={24}
                                      style={{ marginRight: '8px' }}
                                    />
                                    <Text fontSize="sm">{emp.username}</Text>
                                  </Box>
                                ))}
                              </Box>
                            ) : (
                              <Text fontSize="sm" color="gray.500">
                                No employees found
                              </Text>
                            )}
                          </PopoverBody>
                        </PopoverContent>
                      )}
                    </Popover>
                  </Tooltip>

                  <Text fontWeight="semibold">Labels</Text>
                  {/* <Box w="100%">
                    <CreatableSelect
                      placeholder="Select or create label"
                      isClearable
                      isMulti
                      value={selectedLabel}
                      options={labellist.map((label) => ({
                        label: label.label_name,
                        value: label.label_id,
                      }))}
                      onChange={(newValue) => setSelectedLabel(newValue || [])}
                      formatCreateLabel={(inputValue) =>
                        `Create new label: "${inputValue}"`
                      }
                    />
                  </Box> */}
                  <Box w="100%">
                    {/* <CreatableSelect
                                    placeholder="Select or create label"
                                    isClearable
                                    isMulti
                                    value={
                          selectedLabel.length > 0
                            ? selectedLabel
                            : (taskdata?.labels || []).map((label) => ({
                                label: label.label_name || label,
                                value: label.label_id || label,
                              }))
                        }
                                    options={labellist.map((label) => ({
                                      label: label.label_name,
                                      value: label.label_id,
                                      __isNew__: false,
                                    }))}
                                    onChange={(newValue) => {
                                      setSelectedLabel(newValue || []);
                                    }}
                                    formatCreateLabel={(inputValue) =>
                                      `Create new label: "${inputValue}"`
                                    }
                                  /> */}

                    <CreatableSelect
                      isDisabled={![1, 2, 3].includes(roleId)}
                      isClearable
                      isMulti
                      placeholder="Select or create label"
                      value={selectedLabel} // ✔ ONLY this
                      options={labellist?.map((label) => ({
                        label: label.label_name,
                        value: label.label_id,
                        __isNew__: false,
                      }))}
                      onChange={(newValue) => {
                        const updated = newValue || [];

                        setSelectedLabel(updated);
                        handleAddLabel(updated); // ← Pass updated list
                      }}
                    />
                  </Box>

                  {/* <Text fontWeight="semibold">Parent</Text>
                    <CreatableSelect
                      isDisabled={![1, 2, 3].includes(roleId)}
                      placeholder="Select Parent"
                      isClearable
                      value={selectedparent}
                      onChange={(selected) => {
                        setSelectedParent(selected);
                      }}
                      options={EpicList.map((epic) => ({
                        value: epic.epic_id,
                        label: epic.epic_name,
                      }))}
                    /> */}

                  <Text fontWeight="semibold">Due date</Text>
                  <Input
                    type="date"
                    size="sm"
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                    onBlur={handleEpicUpdate}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleEpicUpdate(); // ✅ Save on Enter
                        e.target.blur();
                      }
                    }}
                    isDisabled={![1, 2, 3].includes(roleId)}
                  />

                  <Text fontWeight="semibold">Start date</Text>
                  <Input
                    type="date"
                    size="sm"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    onBlur={handleEpicUpdate}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleEpicUpdate();
                        e.target.blur();
                      }
                    }}
                    isDisabled={![1, 2, 3].includes(roleId)}
                  />

                  <Text fontWeight="semibold">Sprint</Text>
                  <Text>
                    {/* {taskDetails?.task?.sprint_name || taskDetails?.sprint_name || 'SCRUM Sprint 1'} */}
                    <CreatableSelect
                      isDisabled={![1, 2, 3].includes(roleId)}
                      placeholder="Select or create sprint"
                      isClearable
                      value={
                        selectedSprint ||
                        sprintOptions.find(
                          (s) => s.label === epicDetails?.sprint_name,
                        ) ||
                        (epicdata?.sprint_name
                          ? {
                              label: epicdata.sprint_name,
                              value: epicdata.sprint_id,
                            }
                          : null)
                      }
                      options={sprintOptions}
                      onChange={(newValue) => {
                        setSelectedSprint(newValue);
                        handleEpicUpdate();
                      }}
                      formatCreateLabel={(inputValue) =>
                        `Create new sprint: "${inputValue}"`
                      }
                    />
                  </Text>

                  <Text fontWeight="semibold">Story points</Text>
                  <Input
                    size="sm"
                    placeholder="Add story points"
                    w="100%"
                    type="number"
                    value={storyPoints}
                    onChange={(e) => setStoryPoints(e.target.value)}
                    onBlur={debouncedUpdate}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleEpicUpdate();
                        e.target.blur();
                      }
                    }}
                    isDisabled={![1, 2, 3].includes(roleId)}
                  />

                  <Text fontWeight="semibold">Development</Text>
                  <VStack align="start" spacing={2}></VStack>

                  <Text fontWeight="semibold">Reporter</Text>
                  <HStack align="center" spacing={2}>
                    <Avatar
                      name={epicdata?.created_by_name || 'Unknown'}
                      size="xs"
                    />
                    <Text fontSize="sm" lineHeight="1">
                      {epicdata?.created_by_name || 'Unknown'}
                    </Text>
                  </HStack>
                </Grid>
                <div
                  style={{
                    marginTop: 0,
                    padding: '12px 16px',
                    // border: '1px solid #e6e6e6',
                    borderRadius: 8,
                    // background: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 10,
                  }}
                >
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                  >
                    <span style={{ width: 120, fontWeight: 300 }}>
                      Created at
                    </span>
                    <Text style={{ color: '#333' }}>
                      {epicdata?.created_at
                        ? dayjs(epicdata?.created_at).format(
                            'DD MMM YYYY, hh:mm A',
                          )
                        : 'Unknown'}
                    </Text>
                  </div>
                  <div
                    style={{ display: 'flex', alignItems: 'center', gap: 16 }}
                  >
                    <span style={{ width: 120, fontWeight: 300 }}>
                      Updated at
                    </span>
                    <Text style={{ color: '#333' }}>
                      {epicdata?.updated_at
                        ? dayjs(epicdata?.updated_at).format(
                            'DD MMM YYYY, hh:mm A',
                          )
                        : 'Unknown'}
                    </Text>
                  </div>
                </div>
              </Box>
            </Flex>
          )}

          {/* {subtaskmodal && selectedSubtask && (
        <SubTaskModal
          isOpen={subtaskmodal}
          subtaskdetails={selectedSubtask}
          onClose={handlesubtaskmodal}
          taskDetails={taskDetails}
          assigneeList={assigneeList}
        />
      )} */}
          <Modal
            isOpen={epicModalOpen}
            onClose={() => setEpicModalOpen(false)}
            isCentered
          >
            <ModalOverlay />
            <ModalContent maxW="700px" minH="300px">
              {' '}
              {/* Increase width here */}
              <ModalHeader>Add Epic</ModalHeader>
              <ModalBody>
                <Text mb={3}>
                  Select a parent work item. Work items can only belong to one
                  parent at a time.
                </Text>
                <Select
                  placeholder="Select Parent"
                  value={selectedEpic}
                  onChange={(e) => setSelectedEpic(Number(e.target.value))} // force same type
                  mt={3}
                >
                  {epicList.map((epic) => (
                    <option key={epic.epic_id} value={epic.epic_id}>
                      {epic.epic_name}
                    </option>
                  ))}
                </Select>
              </ModalBody>
              <ModalFooter>
                <Button
                  colorScheme="blue"
                  mr={3}
                  onClick={() => {
                    // Replace with API call
                    setEpicModalOpen(false);
                  }}
                >
                  Add
                </Button>
                <Button variant="ghost" onClick={() => setEpicModalOpen(false)}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </Box>
      </div>
    </Card>
  );
};

export default NewTabEpicdetails;
